module.exports = __webpack_public_path__ + "img/1497556063.28fdd230.jpg";